import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useRef, useEffect } from "react";
import "./UserForm.css";
import { useNavigate } from "react-router-dom";
import "../Responsive/TableResponsive.css";
import "../Responsive/FormResponsive.css";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import "./voyageForm.css";
import "./monthlyInventory.css";
import { MdDeleteOutline } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import { FiUpload } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import Select from "react-select";

function MonthlyInventoryReport({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const popupRef = useRef(null);
  const [description, setDescription] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);

  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };

  const handleCancelClick = () => {
    navigate("/monthly-inventory-report-list");
  };

  // Documents with single upload only (Physical Inventory Certificate & AC2A)
  const singleUploadDocuments = {
    physicalInventory: {
      physical_inventory_certificate: {
        label: "Physical Inventory Certificate",
        key: "physicalInventoryCertificate",
      },
    },
    ac2a: {
      ac2a_document: {
        label: "AC2A Document",
        key: "ac2aDocument",
      },
    },
  };

  // Documents with both single and multiple upload options
  const multiUploadDocuments = {
    bunkeringSummary: {
      bunkering_summary: {
        single: {
          label: "bunkering Summary (Single)",
          key: "bunkeringSummarySingle",
        },
        multiple: {
          label: "bunkering Summary (Multiple)",
          key: "bunkeringSummaryMultiple",
        },
      },
    },
    suppliesNavy: {
      supplies_navy: {
        single: {
          label: "Supplies to Navy (Single)",
          key: "suppliesNavySingle",
        },
        multiple: {
          label: "Supplies to Navy (Multiple)",
          key: "suppliesNavyMultiple",
        },
      },
    },
    suppliesCoastGuard: {
      supplies_coast_guard: {
        single: {
          label: "Supplies to Coast Guard (Single)",
          key: "suppliesCoastGuardSingle",
        },
        multiple: {
          label: "Supplies to Coast Guard (Multiple)",
          key: "suppliesCoastGuardMultiple",
        },
      },
    },
    supplyToRo: {
      supply_to_ro: {
        single: {
          label: "Supply to RO (Single)",
          key: "supplyToRoSingle",
        },
        multiple: {
          label: "Supply to RO (Multiple)",
          key: "supplyToRoMultiple",
        },
      },
    },
  };

  // Initialize upload states for single upload documents
  const initSingleUploadStates = (documents) => {
    const states = {};
    Object.keys(documents).forEach((category) => {
      const docs = documents[category];
      Object.keys(docs).forEach((doc) => {
        const key = docs[doc].key;
        states[`selected${key.charAt(0).toUpperCase() + key.slice(1)}Files`] =
          [];
        states[
          `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`
        ] = false;
      });
    });
    return states;
  };

  // Initialize upload states for multi upload documents
  const initMultiUploadStates = (documents) => {
    const states = {};
    Object.keys(documents).forEach((category) => {
      const docs = documents[category];
      Object.keys(docs).forEach((doc) => {
        Object.keys(docs[doc]).forEach((uploadType) => {
          const key = docs[doc][uploadType].key;
          states[`selected${key.charAt(0).toUpperCase() + key.slice(1)}Files`] =
            [];
          states[
            `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`
          ] = false;
        });
      });
    });
    return states;
  };

  // Upload states for all categories
  const [uploadStates, setUploadStates] = useState({
    physicalInventory: initSingleUploadStates({
      physicalInventory: singleUploadDocuments.physicalInventory,
    }),
    ac2a: initSingleUploadStates({ ac2a: singleUploadDocuments.ac2a }),
    bunkeringSummary: initMultiUploadStates({
      bunkeringSummary: multiUploadDocuments.bunkeringSummary,
    }),
    suppliesNavy: initMultiUploadStates({
      suppliesNavy: multiUploadDocuments.suppliesNavy,
    }),
    suppliesCoastGuard: initMultiUploadStates({
      suppliesCoastGuard: multiUploadDocuments.suppliesCoastGuard,
    }),
    supplyToRo: initMultiUploadStates({
      supplyToRo: multiUploadDocuments.supplyToRo,
    }),
  });

  // File input refs
  const fileRefs = {
    physicalInventoryCertificate: useRef(null),
    ac2aDocument: useRef(null),
    bunkeringSummarySingle: useRef(null),
    bunkeringSummaryMultiple: useRef(null),
    suppliesNavySingle: useRef(null),
    suppliesNavyMultiple: useRef(null),
    suppliesCoastGuardSingle: useRef(null),
    suppliesCoastGuardMultiple: useRef(null),
    supplyToRoSingle: useRef(null),
    supplyToRoMultiple: useRef(null),
  };

  // Handle single file upload
  const handleSingleUpload = (category, docType, event, isMultiple = false) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    let key;
    if (
      singleUploadDocuments[category] &&
      singleUploadDocuments[category][docType]
    ) {
      key = singleUploadDocuments[category][docType].key;
    } else if (
      multiUploadDocuments[category] &&
      multiUploadDocuments[category][docType]
    ) {
      key = multiUploadDocuments[category][docType].single
        ? multiUploadDocuments[category][docType].single.key
        : multiUploadDocuments[category][docType].multiple.key;
    }

    if (!key) return;

    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;

    const fileDetails = [];
    const filesToProcess = isMultiple ? Array.from(files) : [files[0]];

    filesToProcess.forEach((file) => {
      fileDetails.push({
        name: file.name,
        size: file.size,
        file,
      });
    });

    setUploadStates((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [selectedKey]: isMultiple
          ? [...(prev[category][selectedKey] || []), ...fileDetails]
          : fileDetails,
      },
    }));
  };

  // Handle multiple file upload
  const handleMultipleUpload = (category, docType, uploadType, event) => {
    console.log("uploadTypeuploadType", uploadType);
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const key = multiUploadDocuments[category][docType][uploadType].key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;

    const fileDetails = Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
      file,
    }));

    setUploadStates((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [selectedKey]: [...(prev[category][selectedKey] || []), ...fileDetails],
      },
    }));
  };

  // Remove uploaded file
  const removeUploadedFile = (category, key, index) => {
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setUploadStates((prev) => {
      const newFiles = (prev[category][selectedKey] || []).filter(
        (_, i) => i !== index
      );
      const newState = {
        ...prev,
        [category]: {
          ...prev[category],
          [selectedKey]: newFiles,
        },
      };

      if (newFiles.length === 0) {
        newState[category][popupKey] = false;
      }

      return newState;
    });
  };

  // Toggle popup
  const togglePopup = (category, key) => {
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setUploadStates((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [popupKey]: !prev[category][popupKey],
      },
    }));
  };

  // Render single upload field
  const renderSingleUploadField = (category, docType, config) => {
    const key = config.key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;
    const files = uploadStates[category][selectedKey] || [];

    return (
      <div className="form-group" key={`${category}-${docType}`}>
        <label htmlFor={`${key}-input`} className="upload-label">
          {config.label}:
        </label>

        <div className="upload-controls">
          <button
            type="button"
            className="challan-btn"
            onClick={() => fileRefs[key]?.current?.click()}
          >
            <FiUpload className="upload-icon" /> Upload File
          </button>

          <input
            id={`${key}-input`}
            type="file"
            ref={fileRefs[key]}
            className="upload-hidden-input"
            onChange={(e) => handleSingleUpload(category, docType, e, false)}
          />

          {files.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={() => togglePopup(category, key)}
                style={{ height: "34px" }}
            >
              <MdAttachFile className="file-icon" /> {files.length}
            </span>
          )}
        </div>

        {uploadStates[category][popupKey] && (
          <div className="attachment-popup" ref={popupRef}>
            <div className="popup-content">
              <div className="popup-header">
                <h4 className="popup-title">Attachments</h4>
                <button
                  className="popup-close-btn"
                  onClick={() => togglePopup(category, key)}
                >
                  <IoCloseOutline className="close-icon" />
                </button>
              </div>
              <div className="popup-body">
                {files.map((file, index) => (
                  <div className="file-item" key={index}>
                    <div className="file-info">
                      <p className="file-name">{file.name}</p>
                      <p className="file-size">
                        {(file.size / 1024).toFixed(2)} KB
                      </p>
                    </div>
                    <div className="file-actions">
                      <Tooltip title="Delete" arrow>
                        <button
                          className="file-action-btn remove-btn"
                          onClick={() =>
                            removeUploadedFile(category, key, index)
                          }
                        >
                          <MdDeleteOutline className="action-icon" />
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Render multi upload field
  const renderMultiUploadField = (category, docType, config) => {
    return (
      <div
        className="form-group multi-upload-group"
        key={`${category}-${docType}`}
      >
        <label className="upload-label main-label">
          {docType.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
          :
        </label>
        {console.log("asasasasaaaasasas", docType)}

        <div className="multi-upload-container">
          {/* Single Upload Option */}
          <div className="upload-option-inventory">
            {renderUploadOption(category, docType, "single", config.single)}
          </div>

          {/* Multiple Upload Option */}
          <div className="upload-option-inventory">
            {renderUploadOption(category, docType, "multiple", config.multiple)}
          </div>
        </div>
      </div>
    );
  };

  // Render upload option (single or multiple)
  const renderUploadOption = (category, docType, uploadType, config) => {
    console.log("uploadTypeuploadTypevvvvvv", uploadType);
    const key = config.key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;
    const files = uploadStates[category][selectedKey] || [];

    return (
      <div className="upload-sub-group">
        <div className="upload-controls-inventory">
          <div className="upload-btn-wrapper">
            <button
              type="button"
              className="challan-btn"
              onClick={() => fileRefs[key]?.current?.click()}
            >
              <FiUpload className="upload-icon" /> Upload File
              {uploadType === "multiple" ? "s" : ""}
            </button>
          </div>

          <input
            id={`${key}-input`}
            type="file"
            ref={fileRefs[key]}
            className="upload-hidden-input"
            multiple={uploadType === "multiple"}
            onChange={(e) => {
              if (uploadType === "multiple") {
                handleMultipleUpload(category, docType, uploadType, e);
              } else {
                handleSingleUpload(category, docType, e, false);
              }
            }}
          />

          <div className="upload-badge-wrapper">
            {files.length > 0 && (
              <span
                className="inquiry-file-btn"
                onClick={() => togglePopup(category, key)}
                style={{ height: "34px" }}
              >
                <MdAttachFile className="file-icon" /> {files.length}
              </span>
            )}
          </div>
        </div>

        {/* <div className="upload-controls-inventory">
          <div className="upload-btn-wrapper">
            <button
              type="button"
              className="challan-btn"
              onClick={() => fileRefs[key]?.current?.click()}
            >
              <FiUpload className="upload-icon" /> Upload File
              {uploadType === "multiple" ? "s" : ""}
            </button>
          </div>

          <input
            id={`${key}-input`}
            type="file"
            ref={fileRefs[key]}
            className="upload-hidden-input"
            multiple={uploadType === "multiple"}
            onChange={(e) => {
              if (uploadType === "multiple") {
                handleMultipleUpload(category, docType, uploadType, e);
              } else {
                handleSingleUpload(category, docType, e, false);
              }
            }}
          />

          {files.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={() => togglePopup(category, key)}
            >
              <MdAttachFile className="file-icon" /> {files.length}
            </span>
          )}
        </div> */}

        {uploadStates[category][popupKey] && (
          <div className="attachment-popup" ref={popupRef}>
            <div className="popup-content">
              <div className="popup-header">
                <h4 className="popup-title">Attachments</h4>
                <button
                  className="popup-close-btn"
                  onClick={() => togglePopup(category, key)}
                >
                  <IoCloseOutline className="close-icon" />
                </button>
              </div>
              <div className="popup-body">
                {files.map((file, index) => (
                  <div className="file-item" key={index}>
                    <div className="file-info">
                      <p className="file-name">{file.name}</p>
                      <p className="file-size">
                        {(file.size / 1024).toFixed(2)} KB
                      </p>
                    </div>
                    <div className="file-actions">
                      <Tooltip title="Delete" arrow>
                        <button
                          className="file-action-btn remove-btn"
                          onClick={() =>
                            removeUploadedFile(category, key, index)
                          }
                        >
                          <MdDeleteOutline className="action-icon" />
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // This maps your React config to the backend keys
  const backendKeys = {
    single: {
      physical_inventory_certificate: "physical_inventory_certificate",
      ac2a_document: "ac2a_doc",
      bunkering_summary: "bunkering_summary_doc",
      supplies_navy: "supplies_to_navy_doc",
      supplies_coast_guard: "supplies_to_coast_guards_doc",
      supply_to_ro: "supply_to_ro_doc",
    },
    multiple: {
      bunkering_summary: "supportive_bunkering_summary",
      supplies_navy: "supportive_supplies_to_navy",
      supplies_coast_guard: "supportive_supplies_to_coast_guards",
      supply_to_ro: "supportive_supply_to_ro",
    },
  };

  const handleSaveClick = async () => {
    const MAX_FILE_SIZE_MB = 10;

    if (!selectedMonth || !selectedYear) {
      setSeverity("warning");
      showSnackbar("Month and Year are required",);
      return;
    }

    try {
      setIsLoading(true);

      const authKey = localStorage.getItem("authKey");
      const formData = new FormData();

      formData.append("month", selectedMonth.value);
      formData.append("year", selectedYear.value);
      formData.append("description", description?.trim() || "");

      const isFileSizeValid = (file) =>
        file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

      const processFiles = (files, formDataKey) => {
        for (const fileDetail of files) {
          const file = fileDetail.file;
          if (file) {
            if (!isFileSizeValid(file)) {
              throw new Error(
                `File "${file.name}" must be ${MAX_FILE_SIZE_MB} MB or less.`
              );
            }
            formData.append(formDataKey, file);
          }
        }
      };

      // ✅ SINGLE DOCS (includes single inside MULTI)
      for (const [category, docs] of Object.entries(singleUploadDocuments)) {
        const state = uploadStates[category];
        if (!state) continue;

        for (const docType of Object.keys(docs)) {
          const backendKey = backendKeys.single[docType] || docType;
          const key = docs[docType].key;
          const selectedKey = `selected${
            key.charAt(0).toUpperCase() + key.slice(1)
          }Files`;
          const selectedFiles = state[selectedKey] || [];
          processFiles(selectedFiles, backendKey);
        }
      }

      // ✅ ALSO: loop single types inside MULTI
      for (const [category, docs] of Object.entries(multiUploadDocuments)) {
        const state = uploadStates[category];
        if (!state) continue;

        for (const docType of Object.keys(docs)) {
          // Handle `single` key:
          if (docs[docType].single) {
            const backendKey = backendKeys.single[docType] || docType;
            const key = docs[docType].single.key;
            const selectedKey = `selected${
              key.charAt(0).toUpperCase() + key.slice(1)
            }Files`;
            const selectedFiles = state[selectedKey] || [];
            processFiles(selectedFiles, backendKey);
          }
        }
      }

      for (const [category, docs] of Object.entries(multiUploadDocuments)) {
        const state = uploadStates[category];
        if (!state) continue;

        for (const docType of Object.keys(docs)) {
          for (const uploadType of Object.keys(docs[docType])) {
            if (uploadType === "single") continue;

            const backendKey =
              backendKeys.multiple[docType] || `${docType}_${uploadType}`;
            const key = docs[docType][uploadType].key;
            const selectedKey = `selected${
              key.charAt(0).toUpperCase() + key.slice(1)
            }Files`;
            const selectedFiles = state[selectedKey] || [];
            processFiles(selectedFiles, backendKey);
          }
        }
      }

      console.log("FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(key, value instanceof File ? value.name : value);
      }

      const response = await axios.post(
        `${API_URL}/api/inventory/product_inventory_report`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        setSeverity("success");
        showSnackbar(response.data?.message || "Report saved successfully!");
        setTimeout(() => {
          navigate("/monthly-inventory-report-list");
        }, 1000);
      } else {
        setSeverity("error");
        showSnackbar(response.data?.message || "Failed to save report.");
      }
    } catch (err) {
      console.error("Save error:", err);
      setSeverity("error");
      showSnackbar(
        err.response?.data?.message || err.message || "Error saving report."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleInputChange = (e) => {
    setDescription(e.target.value);
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content" ref={containerRef}>
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New Monthly Inventory Report</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail" onKeyDown={handleKeyDown}>
              <div className="form-group">
                <label htmlFor="month_year">Month and Year <span className="text-danger">*</span></label>
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Select
                    options={monthOptions}
                    value={selectedMonth}
                    onChange={setSelectedMonth}
                    placeholder="Select Month"
                    className="monthly_report_select"
                  />

                  <Select
                    options={yearOptions}
                    value={selectedYear}
                    onChange={setSelectedYear}
                    placeholder="Select Year"
                    className="monthly_report_select"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="work_description">Description</label>
                <div className="">
                  <textarea
                    name="work_description"
                    rows={4}
                    cols={10}
                    value={description}
                    onChange={handleInputChange}
                    className="group-inventory-textarea"
                    placeholder="Enter description"
                  />
                </div>
              </div>

              <div className="new-data-form">
                <div className="form-group">
                  <label htmlFor="doc_name"></label>
                  <div className="input-group">
                    <div className="error-messages125">
                      File size must be 10 MB or less.
                    </div>
                  </div>
                </div>

                {/* Physical Inventory Certificate */}
                {renderSingleUploadField(
                  "physicalInventory",
                  "physical_inventory_certificate",
                  singleUploadDocuments.physicalInventory
                    .physical_inventory_certificate
                )}

                {/* AC2A Document */}
                {renderSingleUploadField(
                  "ac2a",
                  "ac2a_document",
                  singleUploadDocuments.ac2a.ac2a_document
                )}

                {/* bunkering Summary */}
                {renderMultiUploadField(
                  "bunkeringSummary",
                  "bunkering_summary",
                  multiUploadDocuments.bunkeringSummary.bunkering_summary
                )}

                {/* Supplies to Navy */}
                {renderMultiUploadField(
                  "suppliesNavy",
                  "supplies_navy",
                  multiUploadDocuments.suppliesNavy.supplies_navy
                )}

                {/* Supplies to Coast Guard */}
                {renderMultiUploadField(
                  "suppliesCoastGuard",
                  "supplies_coast_guard",
                  multiUploadDocuments.suppliesCoastGuard.supplies_coast_guard
                )}

                {/* Supply to RO */}
                {renderMultiUploadField(
                  "supplyToRo",
                  "supply_to_ro",
                  multiUploadDocuments.supplyToRo.supply_to_ro
                )}
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default MonthlyInventoryReport;
